import LOCAL_STORAGE from "../utils/localStorage";

const monthNames = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];
const dayOfWeekNames = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

const twoDigitPad = (num) => {
  return num < 10 ? "0" + num : num;
};

export const formatDate = (date, patternStr) => {
  if (!patternStr) patternStr = "M/d/yyyy";

  const day = date.getDate(),
    month = date.getMonth(),
    year = date.getFullYear(),
    hour = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds(),
    miliseconds = date.getMilliseconds(),
    h = hour % 12 || 12, // Use 12 instead of 0 for midnight/noon
    hh = twoDigitPad(h),
    HH = twoDigitPad(hour),
    mm = twoDigitPad(minute),
    ss = twoDigitPad(second),
    aaa = hour < 12 ? "am" : "pm",
    EEEE = dayOfWeekNames[date.getDay()],
    EEE = EEEE.substr(0, 3),
    dd = twoDigitPad(day),
    M = month + 1,
    MM = twoDigitPad(M),
    MMMM = monthNames[month],
    MMM = MMMM.substr(0, 3),
    yyyy = year + "",
    yy = yyyy.substr(2, 2);
  // checks to see if month name will be used
  patternStr = patternStr
    .replace("hh", hh)
    .replace("h", h)
    .replace("HH", HH)
    .replace("H", hour)
    .replace("mm", mm)
    .replace("m", minute)
    .replace("ss", ss)
    .replace("s", second)
    .replace("S", miliseconds)
    .replace("dd", dd)
    .replace("d", day)

    .replace("EEEE", EEEE)
    .replace("EEE", EEE)
    .replace("yyyy", yyyy)
    .replace("yy", yy)
    .replace("aaa", aaa);
  if (patternStr.indexOf("MMM") > -1) {
    patternStr = patternStr.replace("MMMM", MMMM).replace("MMM", MMM);
  } else {
    patternStr = patternStr.replace("MM", MM).replace("M", M);
  }
  return patternStr;
};

export const formatTime = (seconds) => {
  if (!seconds) return "00:00";

  const hh = Math.floor(seconds / 3600),
    mm = Math.floor(seconds / 60) % 60,
    ss = Math.floor(seconds) % 60;

  if (hh) {
    return (
      (hh < 10 ? "0" : "") +
      hh +
      ":" +
      (mm < 10 ? "0" : "") +
      mm +
      ":" +
      (ss < 10 ? "0" : "") +
      ss
    );
  } else {
    return (mm < 10 ? "0" : "") + mm + ":" + (ss < 10 ? "0" : "") + ss;
  }
};

export const setCssVariables = (colors) => {
  const root = document.documentElement;

  root.style.setProperty("--primary-color", colors.primary_color);
  root.style.setProperty("--color-secondary", "#555");
  root.style.setProperty("--color-tertiary", "#777");
  root.style.setProperty("--color-quaternary", "#999");
  root.style.setProperty("--color-quinary", "#bbb");
  root.style.setProperty("--color-senary", "#ddd");
  root.style.setProperty("--color-septenary", "#fff");
  root.style.setProperty("--color-octonary", "#000");
  root.style.setProperty("--color-nonary", "#222");
  root.style.setProperty("--color-denary", "#444");
};

export const constructQueryString = (queryParams) => {
  return Object.keys(queryParams)
    .map(
      (key) =>
        encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])
    )
    .join("&");
};

export const throttle = (func, limit) => {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

export const debounce = (func, delay) => {
  let inDebounce;
  return function () {
    const args = arguments;
    const context = this;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

export const generateMacAddress = (str) => {
  // str replace all symbols except numbers and letters

  str = str.replace(/[^a-z0-9]/gi, "");

  const mac = [];

  if (str.length < 12) {
    const chars = "abcdef0123456789";

    const count = 12 - str.length;

    for (let i = 0; i < count; i++) {
      str += chars.charAt(Math.floor(Math.random() * chars.length));
    }
  }

  for (let i = 0; i < 6; i++) {
    mac.push(str.substr(i * 2, 2));
  }

  return mac.join(":");
};

export const scrollElement = (
  element,
  type = "X",
  size = "0rem",
  duration = 0
) => {
  if (!element) return;

  element.style.transform = `translate${type.toUpperCase()}(${size})`;
};

export const imageResizer = (host, imageUrl, width, height, fit, format) => {
  let url = "";

  if (!host) return;
  try {
    const newurl = btoa(unescape(encodeURIComponent(imageUrl)));
    const newhost = host;
    let size = "";

    if (height) {
      size = width + "x" + height;
    } else {
      size = width;
    }

    const hash = "btoa_escape";
    let is_blured = "";

    // if (format) {
    //   is_blured += "&format=" + format;
    // }

    url =
      newhost +
      "?url=" +
      newurl +
      "&size=" +
      size +
      "&fit=" +
      fit +
      "&hash=" +
      hash +
      is_blured;
  } catch (error) {
    console.log(error, "error");
  }

  return url;
};

export const setUrlArchive = (item, currentChannel) => {
  let _url = "";
  let __host = "";
  const ip = currentChannel.archived_channel.archiver.ip;

  if (ip.indexOf("https") > -1) __host = ip;
  else __host = ip + ":" + currentChannel.archived_channel.archiver.port;

  _url =
    __host +
    "/archive/" +
    currentChannel.archived_channel.channelId +
    "/index.m3u8" +
    "?start=" +
    item.start_ut +
    "&duration=" +
    (item.stop_ut - item.start_ut);

  return _url;
};

export const screenSize = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return { width, height };
};

// export const setPlayerPosition = (isPipMode = false) => {
//   if (!window.Android) return;

//   const { width, height } = screenSize();

//   // Calculate if dimensions are approximately equal (within 5% margin)
//   const isApprox1920 = Math.abs(width - 1920) <= 96; // 5% of 1920
//   const isApprox1080 = Math.abs(height - 1080) <= 54; // 5% of 1080
//   const isApprox1280 = Math.abs(width - 1280) <= 64; // 5% of 1280
//   const isApprox720 = Math.abs(height - 720) <= 36; // 5% of 720

//   // Calculate scale factors for different resolutions
//   const scale1080p = width / 1920;
//   const scale720p = width / 1280;

//   if (isPipMode) {
//     if (isApprox1920 && isApprox1080) {
//       // For 1080p-like resolutions
//       window.PLAYER.setPositionPlayer(
//         Math.round(720),
//         Math.round(403),
//         Math.round(1061),
//         Math.round(224),
//         window.innerWidth,
//         window.innerHeight
//       );
//     } else if (isApprox1280 && isApprox720) {
//       // For 720p-like resolutions
//       window.PLAYER.setPositionPlayer(
//         Math.round(520),
//         Math.round(303),
//         Math.round(731),
//         Math.round(124),
//         window.innerWidth,
//         window.innerHeight
//       );
//     } else {
//       // For other resolutions, scale based on width
//       const scale = width / 1920;
//       window.PLAYER.setPositionPlayer(
//         Math.round(720),
//         Math.round(403),
//         Math.round(1061),
//         Math.round(224),
//         window.innerWidth,
//         window.innerHeight
//       );
//     }
//   } else {
//     // Full screen mode - always use full screen dimensions
//     window.PLAYER.setPositionPlayer(
//       window.innerWidth,
//       window.innerHeight,
//       0,
//       0,
//       window.innerWidth,
//       window.innerHeight
//     );
//   }

//   // Log dimensions for debugging
//   console.log("Player positioning:", isPipMode, {
//     screenWidth: width,
//     screenHeight: height,
//     isPipMode,
//     isApprox1920,
//     isApprox1080,
//     isApprox1280,
//     isApprox720,
//     scale1080p,
//     scale720p,
//   });
// };

export const setPlayerPosition = (isPipMode = false) => {
  if (!window.Android) return;

  const { width, height } = screenSize();

  if (isPipMode) {
    // Reference resolution: 980x552
    const widthScale = width / 980;
    const heightScale = height / 552;

    const scaledWidth = Math.round(400 * widthScale);
    const scaledHeight = Math.round(403 * heightScale);
    const scaledX = Math.round(560 * widthScale);
    const scaledY = Math.round(24 * heightScale);

    window.PLAYER.setPositionPlayer(
      scaledWidth,
      scaledHeight,
      scaledX,
      scaledY,
      window.innerWidth,
      window.innerHeight
    );
  } else {
    // Full screen mode - always use full screen dimensions
    window.PLAYER.setPositionPlayer(
      window.innerWidth,
      window.innerHeight,
      0,
      0,
      window.innerWidth,
      window.innerHeight
    );
  }
};

// 400, 403, 560, 24

// export const setPlayerPosition = (isPipMode = false) => {
//   if (!window.Android) return;

//   const { width, height } = screenSize();

//   // Base reference dimensions (16:9 aspect ratio)
//   const baseWidth = 1920;
//   const baseHeight = 1080;

//   // Calculate aspect ratio
//   const currentAspectRatio = width / height;
//   const baseAspectRatio = baseWidth / baseHeight;

//   // Determine scaling and positioning dynamically
//   const calculatePipDimensions = () => {
//     // Base PiP dimensions for 1080p
//     const basePipWidth = 1061;
//     const basePipHeight = 224;
//     const basePipX = 720;
//     const basePipY = 403;

//     // Calculate scaling factor based on screen width
//     const scale = width / baseWidth;

//     // Adjust dimensions proportionally
//     const pipWidth = Math.round(basePipWidth * scale);
//     const pipHeight = Math.round(basePipHeight * scale);
//     const pipX = Math.round(basePipX * scale);
//     const pipY = Math.round(basePipY * scale);

//     return {
//       width: pipWidth,
//       height: pipHeight,
//       x: pipX,
//       y: pipY,
//     };
//   };

//   if (isPipMode) {
//     const {
//       width: pipWidth,
//       height: pipHeight,
//       x: pipX,
//       y: pipY,
//     } = calculatePipDimensions();

//     window.PLAYER.setPositionPlayer(
//       pipX,
//       pipY,
//       pipWidth,
//       pipHeight,
//       window.innerWidth,
//       window.innerHeight
//     );
//   } else {
//     // Full screen mode - always use full screen dimensions
//     window.PLAYER.setPositionPlayer(
//       window.innerWidth,
//       window.innerHeight,
//       0,
//       0,
//       window.innerWidth,
//       window.innerHeight
//     );
//   }

//   // Logging for debugging
//   console.log("Player positioning:", {
//     screenWidth: width,
//     screenHeight: height,
//     isPipMode,
//     aspectRatio: currentAspectRatio.toFixed(2),
//     baseAspectRatio: baseAspectRatio.toFixed(2),
//     pipDimensions: isPipMode ? calculatePipDimensions() : null,
//   });
// };

// export const setPlayerPosition = (isPipMode = false) => {
//   if (!window.Android) return;

//   const { width, height } = screenSize();

//   // Base reference dimensions (16:9 aspect ratio)
//   const baseWidth = 1920;
//   const baseHeight = 1080;

//   // Calculate aspect ratio
//   const currentAspectRatio = width / height;
//   const baseAspectRatio = baseWidth / baseHeight;

//   // Determine scaling and positioning dynamically
//   const calculatePipDimensions = () => {
//     // Base PiP dimensions for 1080p
//     const basePipWidth = 1161;
//     const basePipHeight = 284;
//     // Reduced X and Y values to move more left and top
//     const basePipX = 580; // Reduced from 780
//     const basePipY = 380; // Reduced from 480

//     // Calculate scaling factor based on screen width
//     const scale = width / baseWidth;

//     // Adjust dimensions proportionally
//     const pipWidth = Math.round(basePipWidth * scale);
//     const pipHeight = Math.round(basePipHeight * scale);
//     const pipX = Math.round(basePipX * scale);
//     const pipY = Math.round(basePipY * scale);

//     return {
//       width: pipWidth,
//       height: pipHeight,
//       x: pipX,
//       y: pipY,
//     };
//   };

//   if (isPipMode) {
//     const {
//       width: pipWidth,
//       height: pipHeight,
//       x: pipX,
//       y: pipY,
//     } = calculatePipDimensions();

//     window.PLAYER.setPositionPlayer(
//       pipX,
//       pipY,
//       pipWidth,
//       pipHeight,
//       window.innerWidth,
//       window.innerHeight
//     );
//   } else {
//     // Full screen mode - always use full screen dimensions
//     window.PLAYER.setPositionPlayer(
//       window.innerWidth,
//       window.innerHeight,
//       0,
//       0,
//       window.innerWidth,
//       window.innerHeight
//     );
//   }

//   // Logging for debugging
//   console.log("Player positioning:", {
//     screenWidth: width,
//     screenHeight: height,
//     isPipMode,
//     aspectRatio: currentAspectRatio.toFixed(2),
//     baseAspectRatio: baseAspectRatio.toFixed(2),
//     pipDimensions: isPipMode ? calculatePipDimensions() : null,
//   });
// };

// window.Android.setPlayerPositions(408,  242, 590, 100, window.innerWidth, window.innerHeight)
// window.Android.setPlayerPositions(408,  242, 590, 110, window.innerWidth, window.innerHeight)
